import { render, staticRenderFns } from "./Counts.vue?vue&type=template&id=52deba04&scoped=true"
import script from "./Counts.vue?vue&type=script&lang=js"
export * from "./Counts.vue?vue&type=script&lang=js"
import style0 from "./Counts.vue?vue&type=style&index=0&id=52deba04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52deba04",
  null
  
)

export default component.exports